import React, { useState } from 'react';

const sections = [
  {
    id: 'intro',
    title: '📋 Introduction',
    icon: '📋',
    content: `PenFlow is a next-generation decentralized blogging and social platform built on the Pi Network blockchain. It combines the best features of WhatsApp, LinkedIn, and Steemit — merged with blockchain technology to create a platform where content creators can Write, Earn Pi, and Connect with pioneers worldwide.

PenFlow is the first platform of the XpertCreation ecosystem, designed to empower Pi Network users with a fully functional social blogging experience on the Pi Blockchain.`
  },
  {
    id: 'vision',
    title: '🎯 Vision & Mission',
    icon: '🎯',
    content: `Vision: To become the leading content platform on Pi Network where every pioneer can monetize their knowledge, creativity, and expertise using Pi cryptocurrency.

Mission: To build a decentralized, censorship-resistant blogging ecosystem that rewards quality content with Pi payments, fosters meaningful connections between pioneers, and creates real utility for Pi cryptocurrency in everyday life.`
  },
  {
    id: 'features',
    title: '⚡ Core Features',
    icon: '⚡',
    items: [
      { name: '✍️ Write & Publish Posts', desc: 'Create rich text blog posts with formatting tools (Bold, Italic, Headings, Quotes, Code blocks, Links). Share your knowledge, stories, and insights with the PenFlow community. Posts are stored on our blockchain-backed database.' },
      { name: '💰 Earn Pi', desc: 'Readers can tip authors directly with Pi cryptocurrency. Every quality post has earning potential. Pi rewards are tracked in your personal ledger with full transaction history including TxID and payment IDs.' },
      { name: '🤝 Connect & Network', desc: 'Build your professional and social network on Pi. Send connection requests, accept connections, and grow your pioneer network. Direct messaging with Pi tip functionality built into chat.' },
      { name: '🌐 Communities', desc: 'Join or create topic-based communities. The official PenFlow community is open to all pioneers. Community moderators can manage members and posts. New users auto-join the default PenFlow community.' },
      { name: '🏆 Leaderboard', desc: 'Top 10 Earners and Top 10 Contributors are featured on the leaderboard. Earn recognition for your contributions to the platform.' },
      { name: '🔔 Notifications', desc: 'Real-time notifications for tips received, comments on your posts, connection requests, mentions (@username), and messages. Bell icon shows unread count.' },
      { name: '💬 Messaging', desc: 'Direct messaging between connected users. Send text messages and Pi tips directly in chat. Chat history is preserved. YouTube and link previews in messages.' },
      { name: '📒 Pi Ledger', desc: 'Complete transaction history for all Pi activity on PenFlow. Track tips sent, tips received, and boost payments. Each transaction shows amount, date, TxID, and payment ID.' },
      { name: '✓ Blue Tick', desc: 'Verified badge for premium users. Pay 1 Pi/month to get a Blue Tick on your profile — showing you are a verified and committed PenFlow pioneer.' },
      { name: '📢 Boost Posts', desc: 'Promote your posts to the top of the feed with Pi payment. Sponsored posts reach more readers and stay pinned for the boost duration.' },
      { name: '🎮 Games', desc: 'Built-in games including TicTacToe Online, Birthday Calculator, BMI Calculator, Currency Converter, Color Picker, QR Generator, and Scientific Calculator — all free to use.' },
      { name: '🛠️ Tools', desc: 'Free utility tools for writers and creators: Word Counter, Typing Tutor, Unit Converter, Birthday Calculator, and more.' },
      { name: '🌍 Multi-Language', desc: 'PenFlow supports 11 languages: English, Urdu, Arabic, Hindi, German, French, Spanish, Chinese, Turkish, Russian, and Portuguese. Change language in Settings.' },
      { name: '🔒 Privacy Controls', desc: 'Set your profile to private — only connected users can see your posts and profile. Public profiles are visible to everyone.' },
      { name: '🌟 Zodiac & Weather', desc: 'Personalized home screen showing your zodiac horoscope (based on date of birth) and local weather. Click for detailed zodiac readings and weather forecasts.' },
    ]
  },
  {
    id: 'blockchain',
    title: '⛓️ Blockchain & Pi Integration',
    icon: '⛓️',
    content: `PenFlow is built on the Pi Network blockchain and uses Pi SDK for all payments and authentication.

Pi Authentication: Users login exclusively through Pi Browser using their Pi Network account. No separate registration required — your Pi username is your PenFlow identity.

Pi Payments: All transactions on PenFlow use Pi cryptocurrency:
- Post Tips: Readers tip authors any amount of Pi
- Blue Tick: 1 Pi/month for verified badge  
- Post Boost: Pi payment to promote posts
- Chat Tips: Send Pi directly in messages

Transaction Security: Every payment goes through Pi Network's payment flow with server-side approval and completion verification. All transactions have TxIDs recorded on the Pi Blockchain.

Developed on Pi Blockchain — PenFlow is a Pi Network dApp (decentralized application) accessible through Pi Browser.`
  },
  {
    id: 'ecosystem',
    title: '🏗️ XpertCreation Ecosystem',
    icon: '🏗️',
    items: [
      { name: '✍️ PenFlow (Live)', desc: 'Blogging & social platform — the platform you are using right now. Write, earn Pi, and connect with pioneers.' },
      { name: '🛍️ Marketplace (Live)', desc: 'Pi-based marketplace for buying and selling physical and digital products directly between Pi merchants and buyers.' },
      { name: '💼 Freelance (Live)', desc: 'Pi-based freelancing marketplace — gigs and job postings, proposals, and escrow-style payments in Pi.' },
      { name: '🏨 Travel (Live)', desc: 'Pi-based stay-booking marketplace — hosts list rooms/apartments/hotels, guests book and pay entirely in Pi.' },
      { name: '📅 Meetup (Live)', desc: 'Find and join events, or create your own groups and gatherings — RSVP and ticketing paid in Pi.' },
      { name: '🎓 Academy (Live)', desc: 'Pi-based online learning platform — enroll in courses paid in Pi, or teach and earn as an instructor.' },
      { name: '🏠 Realty (Live)', desc: 'Pi-based real estate platform — post, browse, and inquire about properties for sale or rent.' },
      { name: '💗 Matrimony (Live)', desc: 'Find a life partner with real, verified Pi-identity profiles.' },
      { name: '🖼️ NFT (Live)', desc: 'Mint, collect, and trade digital collectible items, paid in Pi.' },
      { name: '🐾 PetCare (Live)', desc: 'Manage pet health records, vet appointments, adoption/sale listings, and lost-and-found reports.' },
      { name: '🌳 Family Tree (Live)', desc: 'Build and share your family history — people, photo albums, and a family phone book.' },
      { name: '🎮 Advanced Games (Live)', desc: 'Snake, Tetris (with real-time online multiplayer), Platformer, Fighter, and UNO — with global leaderboards.' },
    ]
  },
  {
    id: 'tokenomics',
    title: '💎 Pi Tokenomics on PenFlow',
    icon: '💎',
    content: `PenFlow creates real utility for Pi cryptocurrency through multiple use cases:

Earning Pi:
- Create quality content and receive tips from readers
- Be a top contributor to earn recognition
- Moderate communities for platform rewards

Spending Pi:
- Tip authors whose content you value
- Get Blue Tick verification (1 Pi/month)
- Boost your posts for more visibility  
- Send Pi tips to friends in chat

Pi Flow: Pi moves directly between pioneers (peer-to-peer) on the Pi Network blockchain. PenFlow facilitates the transactions but does not hold or control user funds. All payments are processed by Pi Network's official payment system.`
  },
  {
    id: 'security',
    title: '🔐 Security & Privacy',
    icon: '🔐',
    content: `Authentication: PenFlow uses Pi Network's official authentication — no passwords stored. Your Pi account is your identity.

Data Privacy: User data is stored securely on our servers. Profile privacy settings let you control who sees your content.

Payment Security: All Pi payments are processed through Pi Network's official payment API. PenFlow never has access to your Pi wallet directly.

Content Moderation: Community moderators and the admin team ensure content quality. Banned words filter prevents inappropriate content. Moderators can remove posts and members from communities.

Admin System: Role-based access control with SuperAdmin (khalidxpert), Admins, Moderators, and Users. Each role has specific permissions.`
  },
  {
    id: 'roadmap',
    title: '🗺️ Roadmap',
    icon: '🗺️',
    items: [
      { name: '✅ Phase 1 — Foundation (Complete)', desc: 'User authentication via Pi, post creation & voting, Pi tipping system, user profiles, connections network, direct messaging, notifications, leaderboard, communities, admin panel.' },
      { name: '✅ Phase 2 — Enhancement (Complete)', desc: 'Blue Tick verification, post boosting, rich text editor, 11-language support, zodiac & weather integration, community moderation.' },
      { name: '✅ Phase 3 — Ecosystem Expansion (Complete)', desc: 'Marketplace, Freelance, Travel, Meetup, Academy, Realty, Matrimony, NFT, PetCare, and Family Tree all launched — a unified admin dashboard and cross-app transaction history tie them together.' },
      { name: '🔄 Phase 4 — Refinement (In Progress)', desc: 'Content moderation filters, deeper currency-conversion coverage across all apps, unified shopping cart across apps, and continued polish.' },
    ]
  },
  {
    id: 'team',
    title: '👥 Team',
    icon: '👥',
    content: `PenFlow is developed by XpertCreation — a technology company focused on building the Pi Network ecosystem.

Founder & CEO: Syed Khalid Hussain Shah (@khalidxpert)
Platform: PenFlow — First platform of XpertCreation
Website: xpertcreation.com
Discord: discord.gg/Dtu976rr3u
Twitter: @khalidxpert

XpertCreation's vision is to build a complete ecosystem of Pi-powered platforms that create real-world utility for Pi cryptocurrency and empower pioneers worldwide.`
  },
];

export default function Whitepaper() {
  const [active, setActive] = useState('intro');
  const current = sections.find(s => s.id === active);

  return (
    <div style={S.page}>
      <div style={S.hero}>
        <div style={{ fontSize: '48px', marginBottom: '8px' }}>📄</div>
        <h1 style={S.heroTitle}>PenFlow Whitepaper</h1>
        <p style={S.heroSub}>v1.0 — June 2026 | Developed on Pi Blockchain</p>
      </div>

      {/* Section tabs */}
      <div style={S.tabs}>
        {sections.map(s => (
          <button key={s.id} onClick={() => setActive(s.id)}
            style={{ ...S.tab, ...(active === s.id ? S.tabActive : {}) }}>
            {s.icon} {s.title.split(' ').slice(1).join(' ')}
          </button>
        ))}
      </div>

      {/* Content */}
      <div style={S.content}>
        <h2 style={S.sectionTitle}>{current.title}</h2>
        {current.content && (
          <div style={S.text}>
            {current.content.split('\n\n').map((para, i) => (
              <p key={i} style={S.para}>{para}</p>
            ))}
          </div>
        )}
        {current.items && (
          <div style={S.itemList}>
            {current.items.map((item, i) => (
              <div key={i} style={S.item}>
                <div style={S.itemTitle}>{item.name}</div>
                <div style={S.itemDesc}>{item.desc}</div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Footer */}
      <div style={S.footer}>
        <p style={{ color: '#999', fontSize: '12px', textAlign: 'center' }}>
          © 2026 XpertCreation | PenFlow Whitepaper v1.0 | Built on Pi Blockchain
        </p>
      </div>
    </div>
  );
}

const S = {
  page: { maxWidth: '800px', margin: '0 auto', paddingBottom: '40px' },
  hero: { background: 'linear-gradient(135deg, #0f0c29, #302b63)', padding: '40px 20px', textAlign: 'center', color: 'white' },
  heroTitle: { fontSize: '28px', fontWeight: '900', margin: '0 0 8px', color: 'white' },
  heroSub: { color: 'rgba(255,215,0,0.8)', fontSize: '14px', margin: 0 },
  tabs: { display: 'flex', gap: '6px', flexWrap: 'wrap', padding: '16px 20px', backgroundColor: '#f9f9f9', borderBottom: '1px solid #eee' },
  tab: { padding: '6px 12px', borderRadius: '15px', border: '1px solid #ddd', backgroundColor: 'white', cursor: 'pointer', fontSize: '12px', fontWeight: '500', color: '#666' },
  tabActive: { backgroundColor: '#6200ea', color: 'white', border: '1px solid #6200ea' },
  content: { padding: '24px 20px' },
  sectionTitle: { color: '#6200ea', fontSize: '20px', marginBottom: '16px' },
  text: { color: '#444', lineHeight: 1.8 },
  para: { marginBottom: '16px', fontSize: '14px' },
  itemList: { display: 'flex', flexDirection: 'column', gap: '12px' },
  item: { backgroundColor: 'white', borderRadius: '12px', padding: '16px', boxShadow: '0 2px 8px rgba(0,0,0,0.06)', borderLeft: '4px solid #6200ea' },
  itemTitle: { fontWeight: 'bold', color: '#333', fontSize: '15px', marginBottom: '6px' },
  itemDesc: { color: '#666', fontSize: '13px', lineHeight: 1.6 },
  footer: { padding: '20px', borderTop: '1px solid #eee' },
};
